import Spinner from "@/components/atoms/Spinner/Spinner";
import { arrow } from "@/designSystemIcons";
import { formatSbcSetName } from "@/pages/Sbcs/SbcSetPage/SbcSetPage";
import GetCardSBC from "@/pages/Sbcs/SbcSetPage/components/GetCardSbc";
import React from "react";
import { NavLink } from "react-router-dom";

export interface SbcSetDesktopViewProps {
  sbcSet: any;
  setHeader: React.ReactNode;
  sbcs: any[];
  getCardSBC: React.ReactNode;
  sbcFiltersSidebar: React.ReactNode;
  name: string;
}

const SbcSetDesktopView: React.FC<SbcSetDesktopViewProps> = ({
  sbcSet,
  setHeader,
  sbcs,
  sbcFiltersSidebar,
  name,
}) => {
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="h-10 flex w-full items-center justify-center bg-[#052432]">
        <div className="flex flex-row items-center w-full max-w-content">
          <NavLink className="flex px-4 py-3" to="/">
            <div className="w-3 rotate-90 text-dark-tertiary">{arrow}</div>
          </NavLink>
          <h1>
            <span>EA FC 25 SBC Solution - </span>
            <span>{formatSbcSetName(name)}</span>
          </h1>
        </div>
      </div>
      <div className="w-full bg-gradient-to-r from-[#3C5165] to-[#091A29]">
        <div className="w-full max-w-content mx-auto">
          <div className="flex items-center justify-between desktop:px-2 min-h-[220px]">
            <div className="flex-1 pr-4">{sbcSet && setHeader}</div>
            <div className="large-desktop:min-w-[340px] large-desktop:max-w-[430px]" />
          </div>
        </div>
      </div>
      <div className="h-10 w-full bg-panel-background" />
      <div className="w-full bg-[#1A1E23] flex justify-center">
        <div className="w-full max-w-content flex desktop:px-2 bg-[#1A1E23] py-4 gap-4">
          <div className="w-full">
            {sbcs?.length > 0 ? (
              <>
                {sbcs.map((sbc, index) => (
                  <GetCardSBC key={sbc.id} sbc={sbc} index={index} />
                ))}
              </>
            ) : (
              <div className="m-auto">
                <Spinner />
              </div>
            )}
          </div>

          <div className="max-w-[430px]">{sbcFiltersSidebar}</div>
        </div>
      </div>
    </div>
  );
};

export default SbcSetDesktopView;
